import {usePromotion} from '@/context/Promotion/PromotionContext'

// rewardIndex selects the reward of the buy condition being validated when individual rewards are enabled
export const useRewardValidations = (promotionCondition, rewardIndex = 0) => {
  const {promotion} = usePromotion()
  const sequenceNumber = promotionCondition?.sequence || 1
  const currentReward = promotionCondition?.rewards?.[rewardIndex]
  const currentRewardValue = currentReward?.discountValue || currentReward?.points || currentReward?.quantity
  const getConditionValue = (condition, condIndex = 0) => {
    const currentCondition = condition?.conditionGroup?.conditions?.[condIndex]
    const isAmountCondition = currentCondition?.items?.[0]?.uom === 'EA' || currentCondition?.amount != null

    if (isAmountCondition) {
      return currentCondition?.amount
    }

    return currentCondition?.quantity
  }

  // get the highest sequence less than the current one (to account for a deleted middle layer)
  const prevCondition = promotion?.promotionConditions
    ?.filter(cond => cond?.sequence < sequenceNumber)
    .sort((a, b) => b.sequence - a.sequence)[0]

  const hasValueLayerError = () => {
    if (sequenceNumber === 1 || !currentRewardValue) return false
    const prevReward = prevCondition?.rewards?.[rewardIndex]
    const prevRewardValue = prevReward?.discountValue || prevReward?.points || prevReward?.quantity
    return prevRewardValue >= currentRewardValue
  }

  const hasBuyQuantityLayerError = (condIndex = 0) => {
    const currentQty = getConditionValue(promotionCondition, condIndex)
    if (sequenceNumber === 1 || !currentQty) return false
    const prevQuantity = getConditionValue(prevCondition, condIndex)
    return prevQuantity >= currentQty || (!prevQuantity && currentQty)
  }

  // Min quantity must be lower than the buy quantity within the same layer/condition
  const hasMinQuantityError = (condIndex = 0) => {
    const currentCondition = promotionCondition?.conditionGroup?.conditions?.[condIndex]
    if (!currentCondition?.hasMinQuantity) return false
    const minQty = currentCondition?.minQuantity
    if (minQty == null) return false
    const buyQty = getConditionValue(promotionCondition, condIndex)
    return buyQty == null || minQty >= buyQty
  }

  // Each layer's min quantity must be higher than the previous layer's min quantity
  const hasMinQuantityLayerError = (condIndex = 0) => {
    const currentCondition = promotionCondition?.conditionGroup?.conditions?.[condIndex]
    if (!currentCondition?.hasMinQuantity) return false
    const currentMinQty = currentCondition?.minQuantity
    if (sequenceNumber === 1 || !currentMinQty) return false
    const prevMinQty = prevCondition?.conditionGroup?.conditions?.[condIndex]?.minQuantity
    return prevMinQty >= currentMinQty || (!prevMinQty && currentMinQty)
  }

  return {
    hasValueLayerError,
    hasBuyQuantityLayerError,
    hasMinQuantityError,
    hasMinQuantityLayerError,
  }
}
